import React, { useState } from "react";
import "./styles.css";
import { Images } from "../../theme";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { DotsLoader } from "../../components";
import { Banks } from "./Bank";

export default function WithDraw(props) {
  const [rowData, setRowData] = useState({});
  const [formErrors, setFormErrors] = useState({});

  const { t } = useTranslation();

  const onChangeInput = async (data) => {
    setFormErrors(false);
    const { selectedInput } = data;
    let upData = { ...rowData };
    upData[selectedInput] = data.value;
    data.state(upData);
  };

  function checkValidation() {
    let { account_name, account_number, bank_name, amount } = rowData;
    if (!account_name) {
      setFormErrors({
        ...formErrors,
        accountNameError: t("Payee Name field cannot be empty"),
      });
    } else if (!account_number) {
      setFormErrors({
        ...formErrors,
        accountNumberError: t("Payee account number field cannot be empty"),
      });
    } else if (!bank_name) {
      setFormErrors({
        ...formErrors,
        backNumberError: t("Please select any bank"),
      });
    } else if (!amount) {
      setFormErrors({
        ...formErrors,
        amountError: t("Amount field cannot be empty"),
      });
    } else if (amount > props.userBalance) {
      setFormErrors({
        ...formErrors,
        amountError: t("Amount cannot greater than current balance"),
      });
    } else {
      let payload = {
        account_name,
        account_number,
        bank_name,
        amount,
      };
      props.widthdrawel(payload);
    }
  }

  return (
    <>
      <p className="withdraw-heading">Withdrawal Request</p>
      <div className="row">
        <div className="col-lg-12">
          <Link to="">
            <div className="px-3">
              <div className="row mt-5">
                <div className="col-lg-5">
                  <p className="draw-label">Payee Account Name: </p>
                </div>
                <div className="col-lg-7">
                  <input
                    type="text"
                    className="draw-input"
                    value={rowData.account_name}
                    onChange={(e) => {
                      onChangeInput({
                        value: e.target.value,
                        state: setRowData,
                        selectedInput: "account_name",
                        selectedRow: rowData,
                      });
                    }}
                  />
                  <div className="error_text">
                    {formErrors.accountNameError}
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-lg-5">
                  <p className="draw-label">Payee Account Number: </p>
                </div>
                <div className="col-lg-7">
                  <input
                    type="text"
                    className="draw-input"
                    value={rowData.account_number}
                    onChange={(e) => {
                      onChangeInput({
                        value: e.target.value,
                        state: setRowData,
                        selectedInput: "account_number",
                        selectedRow: rowData,
                      });
                    }}
                  />
                  <div className="error_text">
                    {formErrors.accountNumberError}
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-lg-5">
                  <p className="draw-label">Payee Bank Name: </p>
                </div>
                <div className="col-lg-7">
                  <select
                    className="draw-input"
                    onChange={(e) =>
                      onChangeInput({
                        value: e.target.value,
                        state: setRowData,
                        selectedInput: "bank_name",
                        selectedRow: rowData,
                      })
                    }
                  >
                    <option value="">Please select bank</option>;
                    {Banks.map((val) => {
                      return <option value={val.Name}>{val.Name}</option>;
                    })}
                  </select>
                  <div className="error_text">{formErrors.backNumberError}</div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-lg-5">
                  <p className="draw-label">Withdrawal Amount (HKD): </p>
                </div>
                <div className="col-lg-7">
                  <input
                    type="text"
                    className="draw-input"
                    value={rowData.amount}
                    onChange={(e) => {
                      onChangeInput({
                        value: e.target.value,
                        state: setRowData,
                        selectedInput: "amount",
                        selectedRow: rowData,
                      });
                    }}
                  />
                  <div className="error_text">{formErrors.amountError}</div>
                </div>
              </div>

              <div className="row mt-5 mb-2">
                <div className="col-lg-12 text-end">
                  <button
                    onClick={checkValidation}
                    class="btn-start btn-light px-5"
                  >
                    {props.isLoading ? <DotsLoader /> : "Submit"}
                  </button>
                </div>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </>
  );
}
